import { EvCar } from "@/models/common";
import {
  Car,
  CarList,
  SearchCarsCondition,
  CarOrder,
  EvCarRequest,
  EvCarLinkedDriverWorkCycles,
} from "@/models/vehicle";
import { AxiosResponse } from "axios";
import qs from "qs";
import { httpClient } from "./API";
import { OfficeLocation } from "@/models/officeLocation";

export const getCarsAPI = async (
  condition: SearchCarsCondition,
  page: number,
  size: number,
  order: CarOrder
): Promise<AxiosResponse<CarList[]>> => {
  const sort = Object.entries(order)
    .filter(([, v]) => !!v)
    .map(([k, v]) => `${k},${v}`);

  return httpClient.get("core/internal/calgary/cars/", {
    params: { ...condition, sort, page: page - (page < 1 ? 0 : 1), size },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat", encode: false }),
  });
};

export const getCarsTotalAPI = async (
  condition: SearchCarsCondition
): Promise<AxiosResponse<{ count: number }>> => {
  return httpClient.get("core/internal/calgary/cars/count/", {
    params: { ...condition },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat", encode: false }),
  });
};

export const getCarAPI = async (id: number): Promise<AxiosResponse<Car>> => {
  return httpClient.get(`core/internal/calgary/cars/${id}`);
};

export const createEvCarAPI = async (
  evCar: EvCarRequest
): Promise<AxiosResponse<EvCar>> => {
  return httpClient.post("core/internal/calgary/evCars", evCar);
};

export const editEvCarAPI = async (
  id: number,
  evCar: EvCarRequest
): Promise<AxiosResponse<EvCar>> => {
  return httpClient.put(`core/internal/calgary/evCars/${id}`, evCar);
};

export const getParkingLotsAPI = async (
  officeId: number
): Promise<AxiosResponse<OfficeLocation[]>> => {
  return httpClient.get("/core/internal/calgary/officeLocations/", {
    params: {
      officeId,
    },
  });
};

export const getReplaceableCarsAPI = async (
  id: number
): Promise<AxiosResponse<Car[]>> => {
  return httpClient.get(`core/internal/calgary/cars/${id}/replaceables`);
};

export const getLinkedDriverWorkCycles = async (
  id: number
): Promise<AxiosResponse<EvCarLinkedDriverWorkCycles>> => {
  return httpClient.get(`core/internal/calgary/evCars/${id}/cycles/`);
};

export const getSelectablePreviousCars = async (
  id: number
): Promise<AxiosResponse<Car[]>> => {
  return httpClient.get(
    `core/internal/calgary/cars/${id}/selectablePreviousCars`
  );
};

export const getUploadedSettingFilesAPI = async (
  id: number
): Promise<AxiosResponse<string[]>> =>
  httpClient.get(`core/internal/calgary/evCars/${id}/obd2`);

export const uploadSettingFileAPI = async (
  id: number,
  file: File
): Promise<AxiosResponse<void>> => {
  const formData = new FormData();
  formData.append("file", file);
  return httpClient.post(`core/internal/calgary/evCars/${id}/obd2`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
